import React from "react";
import Route from "../../components/Route";
import About from "./About";
import Chapter1 from "./Chapter1";
import Chapter2 from "./Chapter2";
import Chapter3 from "./Chapter3";
import Chapter4 from "./Chapter4";
import Chapter5 from "./Chapter5";
import Chapter6 from "./Chapter6";
import Chapter7 from "./Chapter7";
import Chapter8 from "./Chapter8";
import Chapter9 from "./Chapter9";
import Chapter10 from "./Chapter10";
import Chapter11 from "./Chapter11";
import Chapter12 from "./Chapter12";
import Chapter13 from "./Chapter13";
import Chapter14 from "./Chapter14";
import Chapter15 from "./Chapter15";
import Chapter16 from "./Chapter16";
import Chapter17 from "./Chapter17";
import Chapter18 from "./Chapter18";

function AnyPercentNoMajorGlitchesNormal() {
  return (
    <Route title="Any% No Major Glitches - Normal">
      <About />
      <Chapter1 />
      <Chapter2 />
      <Chapter3 />
      <Chapter4 />
      <Chapter5 />
      <Chapter6 />
      <Chapter7 />
      <Chapter8 />
      <Chapter9 />
      <Chapter10 />
      <Chapter11 />
      <Chapter12 />
      <Chapter13 />
      <Chapter14 />
      <Chapter15 />
      <Chapter16 />
      <Chapter17 />
      <Chapter18 />
    </Route>
  );
}

export default AnyPercentNoMajorGlitchesNormal;
